import { createSlice } from '@reduxjs/toolkit';
import { getMktOverview, getMktInstagramInsights, getMktFacebookInsights, getMktGoogleAdsInsights } from 'src/actions/v2/marketing/analytics/v2_actionMktInsights';
import { listMktAccounts } from 'src/actions/v2/marketing/analytics/v2_actionMktAccounts';
import { listMktPosts } from 'src/actions/v2/marketing/analytics/v2_actionMktPosts';

const initialState = {
    isLoading: false,
    error: false,
    accounts: [],
    posts: [],
    insights: {
        overview: null,
        instagram: null,
        facebook: null,
        googleAds: null
    },
    activeTab: 'overview'
};

const slice = createSlice({
    name: 'mktAnalytics',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getAccountsSuccess(state, action) {
            state.isLoading = false;
            state.accounts = action.payload;
        },
        getPostsSuccess(state, action) {
            state.isLoading = false;
            state.posts = action.payload;
        },
        getOverviewSuccess(state, action) {
            state.isLoading = false;
            state.insights.overview = action.payload;
        },
        getInstagramSuccess(state, action) {
            state.isLoading = false;
            state.insights.instagram = action.payload;
        },
        getFacebookSuccess(state, action) {
            state.isLoading = false;
            state.insights.facebook = action.payload;
        },
        getGoogleAdsSuccess(state, action) {
            state.isLoading = false;
            state.insights.googleAds = action.payload;
        },
        setActiveTab(state, action) {
            state.activeTab = action.payload;
        }
    }
});

export default slice.reducer;
export const { setActiveTab } = slice.actions;

export function fetchAccounts(clienteId) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await listMktAccounts(clienteId);
            dispatch(slice.actions.getAccountsSuccess(response.data.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function fetchPosts(clienteId, querys) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await listMktPosts(clienteId, querys);
            dispatch(slice.actions.getPostsSuccess(response.data.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function fetchOverview(clienteId, querys) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await getMktOverview(clienteId, querys);
            dispatch(slice.actions.getOverviewSuccess(response.data.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function fetchInstagramInsights(clienteId, querys) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await getMktInstagramInsights(clienteId, querys);
            dispatch(slice.actions.getInstagramSuccess(response.data.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function fetchFacebookInsights(clienteId, querys) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await getMktFacebookInsights(clienteId, querys);
            dispatch(slice.actions.getFacebookSuccess(response.data.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function fetchGoogleAdsInsights(clienteId, querys) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await getMktGoogleAdsInsights(clienteId, querys);
            dispatch(slice.actions.getGoogleAdsSuccess(response.data.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
